import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  Select,
  MenuItem,
  Typography,
  Checkbox,
  DialogActions,
  DialogTitle,
  Dialog,
  DialogContent,
  TextField,
  FormControl,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import {
  useLazyDeleteTutorByIdQuery,
  useLazyGetAllTutorListingQuery,
  useLazyTutorCsvQuery,
} from "../../services/tutor";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { successToast, errorToast } from "../../helpers";
import Loader from "../../helpers/Loader";
import WarnModal from "../../components/modals/WarnModal";
import Pagination from "../../components/Pagination";
import { usePutTutorProfileMutation } from "../../services/tutor";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validation";
import { Add } from "@mui/icons-material";
import {
  useGetTutorListQuery,
  useLazyDeleteByIdClassQuery,
  useLazyGetAllClassQuery,
  useUpdateClassMutation,
} from "../../services/class";

const Accepted = ({}: any) => {
  const [exportCsv] = useLazyTutorCsvQuery();
  const [page, setPage] = useState(1);
  const [selectAll, setSelectAll] = useState(false);
  const [stateofTutor, setstateofTutor] = useState<{ [key: string]: number }>(
    {}
  );
  const [deleteById] = useLazyDeleteByIdClassQuery();
  const [updateTutorStatus] = usePutTutorProfileMutation();
  const [open, setOpen] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  let totalPages = Math.ceil(totalCount / 10);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const navigate = useNavigate();
  const [rows, setRows] = useState<any>();
  const [value, setValue] = useState<number>(1);
  const [tututorStatust, settututorStatust] = useState<number>(2);
  const [getAllTutorList, { isLoading }] = useLazyGetAllTutorListingQuery();
  const [updateClassStatus] = useUpdateClassMutation();
  const [getAllClass] = useLazyGetAllClassQuery();
  const [selectedId, setSelectedId] = useState<string>("");
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [seats, setSeats] = useState<any>();
  const { data: tutorData } = useGetTutorListQuery();
  const [selectedTutor, setSelectedTutor] = useState("");

  const handleTutorChange = (event: any) => {
    setSelectedTutor(event.target.value);
  };

  const [addPromoCodes, setAddPromoCodes] = useState<any>();
  const [openPromo, setOpenPromo] = useState(false);
  const handlePromoClose = () => {
    setOpenPromo(false);
  };
  const onPageChange = (newPage: number) => {
    setPage(newPage);
    setRows([]);
  };

  const handleRowCheckboxClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    rowId: string
  ) => {
    if (event.target.checked) {
      setSelectedRows((prevSelected) => [...prevSelected, rowId]);
    } else {
      setSelectedRows((prevSelected) =>
        prevSelected.filter((id) => id !== rowId)
      );
    }
  };
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectAll(event.target.checked);
    setSelectedRows(
      event.target.checked ? rows.map((r: { _id: any }) => r._id) : []
    );
  };

  const fetchClass = async () => {
    try {
      const response = await getAllClass({
        page: page,
        search: searchTerm,
        classStatus: 2,
        ...(selectedTutor ? { tutorId: selectedTutor } : {}),
      }).unwrap();
      if (response.statusCode === 200) {
        setRows(response.data?.data);
        setTotalCount(response?.data?.total);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleIncreaseLimit = async () => {
    if (addPromoCodes === "" || addPromoCodes == 0) return;

    try {
      const body = {
        addSeats: Number(addPromoCodes),
        // addSeats: Number(addPromoCodes) + Number(seats),
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      const response = await updateClassStatus({
        id: String(selectedId),
        body: encryptedBody,
      }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Class updated successfully");
        setOpenPromo(false);
        setAddPromoCodes("");
        fetchClass();
      }
    } catch (error: any) {
      errorToast(error?.message);
      console.error(error);
    }
  };
  const changeClassStatus = async (classIds: string, classStatus: string) => {
    if (classStatus === "") return;
    try {
      const body = {
        classStatus: 3,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      const response = await updateClassStatus({
        id: classIds,
        body: encryptedBody,
      }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Class State updated successfully");
        fetchClass();
      }
    } catch (error: any) {
      errorToast(error?.message);
      console.error(error);
    }
  };

  // const handleReject = async () => {
  //   if (selectedRows.length === 0) {
  //     errorToast("Please select at least one row to reject.");
  //     return;
  //   }
  //   await changeUserStatus(selectedRows, "reject");
  // };

  // const fetchRejectedTutor = async (
  //   page: number,
  //   search: string,
  //   tutorStatus: number
  // ) => {
  //   try {
  //     const response = await getAllTutorList({
  //       page,
  //       search,
  //       tutorStatus: String(tutorStatus),
  //       isDelete: false,
  //     }).unwrap();
  //     if (response.statusCode === 200) {
  //       // setRows(response.data?.tutor || []);
  //       // setTotalCount(response?.data?.totalTutor);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  // const fetchApi = async (tutorId: string[], tutorStatus: boolean) => {
  //   try {
  //     const body = {
  //       ids: tutorId,
  //       status: "tutorUpdate",
  //       isBlocked: String(tutorStatus),
  //     };
  //     const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

  //     const response = await updateTutorStatus({ encryptedBody }).unwrap();
  //     if (response?.statusCode === 200) {
  //       successToast("Tutor Account Status updated successfully");
  //     }
  //   } catch (error: any) {
  //     errorToast(error?.message);
  //     console.error(error);
  //   }
  // };
  // const fetchApiForVerify = async (tutorId: string[], tutorStatus: boolean) => {
  //   try {
  //     const body = {
  //       ids: tutorId,
  //       status: "tutorUpdate",
  //       documentVerification: tutorStatus,
  //     };
  //     const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

  //     const response = await updateTutorStatus({ encryptedBody }).unwrap();
  //     if (response?.statusCode === 200) {
  //       successToast("Account Verified successfully");
  //     }
  //   } catch (error: any) {
  //     errorToast(error?.message);
  //     console.error(error);
  //   }
  // };

  // const changeUserStatus = async (tutorId: string[], tutorStatus: string) => {
  //   try {
  //     const body = {
  //       status: tutorStatus,
  //       ids: tutorId,
  //     };
  //     const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

  //     const response = await updateTutorStatus({ encryptedBody }).unwrap();
  //     if (response?.statusCode === 200) {
  //       successToast("Tutor State updated successfully");
  //       fetchRejectedTutor(page, debouncedSearchTerm, tututorStatust);
  //     }
  //   } catch (error: any) {
  //     errorToast(error?.message);
  //     console.error(error);
  //   }
  // };

  const handleDelete = async (classId: any) => {
    try {
      const response = await deleteById({ classId }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Class deleted successfully");
        fetchClass();
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.message || "");
    }
  };

  const handleStatus = async (ids: string, status: boolean) => {
    // if (classStatus === "") return;
    try {
      const body = {
        status,
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      const response = await updateClassStatus({
        id: ids,
        body: encryptedBody,
      }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Status updated successfully");
        fetchClass();
      }
    } catch (error: any) {
      errorToast(error?.message);
      console.error(error);
    }
  };

  // const handleExportCsv = async () => {
  //   try {
  //     const res = await exportCsv({ tutorStatus: 2 }).unwrap();

  //     const parsedRes = typeof res === "string" ? JSON.parse(res) : res;

  //     if (parsedRes && parsedRes.message && parsedRes.message.s3Location) {
  //       window.open(parsedRes.message.s3Location);
  //       successToast("Csv exported successfully");
  //     } else {
  //       errorToast("Error: s3Location not found in response");
  //     }
  //   } catch (error: any) {
  //     errorToast(error?.message);
  //   }
  // };

  // useEffect(() => {
  //   if (value === 1 && tututorStatust === 2) {
  //     fetchRejectedTutor(page, searchTerm, tututorStatust);
  //   }
  // }, [page, searchTerm, tututorStatust, value]);

  useEffect(() => {
    fetchClass();
  }, [page, searchTerm, value, selectedTutor]);

  return (
    <div>
      <Loader isLoad={isLoading} />
      <Box className="cards_header">
        <SearchBar
          value={searchTerm}
          searchTerm={searchTerm}
          onCross={() => setSearchTerm("")}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          onChange={(val: any) => {
            if (isValidInput(val.target.value)) {
              setSearchTerm(val.target.value);
            }
          }}
        />
        <Box className="cards_header_right">
          <FormControl fullWidth>
            <Select
              className="select_div"
              value={selectedTutor}
              displayEmpty
              // disabled={Boolean(_id)}
              onChange={handleTutorChange}
            >
              <MenuItem value="">Select Tutor</MenuItem>
              {tutorData?.data?.map((item: any) => (
                <MenuItem key={item._id} value={item._id}>
                  {item.userName} ({item.name})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* <Button
            className="btn btn_primary"
            variant="contained"
            style={{
              backgroundColor: "black",
              color: "#ffffff",
              // marginLeft: "10px",
            }}
            // onClick={handleReject}
          >
            Reject
          </Button> */}

          {/* <Button
            className="btn btn_primary"
            // onClick={handleExportCsv}
          >
            <FileDownloadIcon /> Export CSV
          </Button> */}
          <Button
            className="btn btn_primary"
            sx={{
              minWidth: 150,
            }}
            onClick={() => navigate("/manage-classes/add")}
          >
            <AddIcon />
            Add Class
          </Button>
          {/* <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-tutor/add")}
          >
            <AddIcon />
            Add Tutor
          </Button> */}
        </Box>
      </Box>
      <TableContainer className="table_container">
        <Box className="heading"></Box>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {/* <TableCell>
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAllClick}
                  inputProps={{ "aria-label": "select all rows" }}
                />
              </TableCell> */}
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Class Thumbnail</TableCell>
              <TableCell align="center">Image</TableCell>
              <TableCell align="center">Full Name</TableCell>
              <TableCell align="center">Contact Number</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">Subject</TableCell>
              <TableCell align="center">Topic</TableCell>
              <TableCell align="center">Seats</TableCell>
              <TableCell align="center">Class Type</TableCell>
              <TableCell align="center">Class Availability</TableCell>

              {/* <TableCell align="center">Request</TableCell> */}
              {/* <TableCell align="center">Status</TableCell> */}
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No Class found
                </TableCell>
              </TableRow>
            ) : (
              rows?.map((row: any, i: any) => (
                <TableRow key={row?._id}>
                  {/* <TableCell>
                    <Checkbox
                      checked={selectedRows.includes(row._id)}
                      onChange={(event) =>
                        handleRowCheckboxClick(event, row._id)
                      }
                    />
                  </TableCell> */}
                  <TableCell align="center">
                    {(page - 1) * 10 + i + 1}
                  </TableCell>
                  <TableCell>
                    <figure>
                      <img
                        style={{
                          width: 100,
                          height: 50,
                        }}
                        src={row?.thumbnail || "static/images/logo.png"}
                        alt=""
                      />
                    </figure>
                  </TableCell>
                  <TableCell>
                    <figure
                      onClick={() =>
                        navigate(`/manage-classes/details/${row._id}`, {
                          state: { userStatus: "PENDING" },
                        })
                      }
                      className="user_img"
                    >
                      <img
                        src={
                          row?.tutor?.image ||
                          "/static/images/user_placeholder.png"
                        }
                        alt=""
                      />
                    </figure>
                  </TableCell>
                  <TableCell>
                    {row?.tutor?.name ? row?.tutor?.name : "-"}
                  </TableCell>
                  {/* <TableCell>{row.userName ? row?.userName : "-"}</TableCell> */}
                  <TableCell>
                    {row?.tutor?.dialCode + row.tutor?.phoneNo}
                  </TableCell>
                  <TableCell>
                    {row.tutor?.email ? row?.tutor?.email : "-"}
                  </TableCell>
                  <TableCell>
                    {row.subjects?.name ? row?.subjects?.name : "-"}
                  </TableCell>
                  <TableCell>
                    {row?.topic?.length >= 30
                      ? row?.topic.slice(0, 30).concat("...")
                      : row?.topic}
                  </TableCell>
                  <TableCell>{row.seats ? row?.seats : "-"}</TableCell>
                  <TableCell>{row.classMode ? "Online" : "Offline"}</TableCell>
                  <TableCell>
                    {row.canBePrivate ? "Private" : "Pubilc"}
                  </TableCell>

                  {/* <TableCell align="center">
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={stateofTutor[row._id] || ""}
                      onChange={(e) => {
                        const selectedOption: any = e.target.value;
                        // setstateofTutor((prevState) => ({
                        //   ...prevState,
                        //   [row._id]: selectedOption,
                        // }));
                        changeClassStatus(row?._id, selectedOption);
                      }}
                      displayEmpty
                    >
                      <MenuItem value="">Approved</MenuItem>
                      <MenuItem value="reject">Reject</MenuItem>
                    </Select>
                  </TableCell> */}
                  {/* <TableCell>
                    <Switch
                      defaultChecked={!row.isBlocked}
                      onChange={(e) => {
                        handleStatus(row?._id, !row?.status);
                      }}
                      size="small"
                    />
                  </TableCell> */}
                  {/* <TableCell>
                    <Switch
                      defaultChecked={row.documentVerification}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        fetchApiForVerify([row._id], isChecked);
                      }}
                      size="small"
                    />
                  </TableCell> */}
                  <TableCell>
                    <Box className="table_actions">
                      <IconButton
                        onClick={() => {
                          setOpenPromo(true);
                          setSelectedId(row?._id);
                          setSeats(row?.seats);
                        }}
                      >
                        <Add />
                      </IconButton>

                      <IconButton
                        onClick={() =>
                          navigate(`/manage-classes/details/${row._id}`, {
                            state: { userStatus: "PENDING" },
                          })
                        }
                      >
                        <VisibilityIcon />
                      </IconButton>
                      {/* <IconButton
                        onClick={() =>
                          navigate(`/manage-classes/edit/${row._id}`)
                        }
                      >
                        <ModeEditIcon />
                      </IconButton> */}
                      {/* <IconButton
                        onClick={() => {
                          setOpen(true);
                          setSelectedId(row?._id);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton> */}
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {rows?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      ) : (
        ""
      )}

      <Dialog
        open={openPromo}
        onClose={handlePromoClose}
        className="revert_dialog"
      >
        <DialogTitle>Add More Seats</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="revert-query-input"
            label="Add More Seats"
            type="text"
            fullWidth
            value={addPromoCodes}
            onChange={(e) => {
              const inputValue = e.target.value;

              // Allow empty input or numbers between 0 and 999
              if (/^\d{0,3}$/.test(inputValue)) {
                // Also ensure value does not exceed 999
                if (inputValue === "" || parseInt(inputValue, 10) <= 99999) {
                  setAddPromoCodes(inputValue);
                }
              }
            }}
            inputProps={{ inputMode: "numeric" }} // improves UX on mobile
          />
        </DialogContent>

        <DialogActions>
          <Button sx={{ background: "#65a442" }} onClick={handlePromoClose}>
            Cancel
          </Button>
          <Button
            sx={{ background: "#65a442" }}
            onClick={handleIncreaseLimit}
            // disabled={revertError || revertQueryInput.trim().length === 0}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <WarnModal
        open={open}
        setOpen={setOpen}
        // handleDelete={() => {}}
        handleDelete={() => handleDelete(selectedId)}
        name="Class"
      />
    </div>
  );
};

export default Accepted;
